import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  FEATURE_FLAGS,
  getFeatureFlagOutsideReact,
} from '../../../../../../lib/featureFlags';
import { sampleSetInterpretiveReportsQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/'
)({
  beforeLoad: async ({ context, params }) => {
    // When the reports_tab flag is on, land on Reports if the sample set has
    // any visible reports (reusing the cached query the layout uses for tab
    // visibility). When off, skip the lookup and land on Samples as before.
    let hasReports = false;
    if (await getFeatureFlagOutsideReact(FEATURE_FLAGS.reportsTab)) {
      try {
        const reports = await context.queryClient.ensureQueryData(
          sampleSetInterpretiveReportsQueryOptions(
            params.sampleSetId,
            context.auth.hasPermission
          )
        );
        hasReports = (reports?.total ?? 0) > 0;
      } catch {
        // Fall back to Samples if the reports lookup fails.
      }
    }
    throw redirect({
      to: hasReports
        ? '/experiments/$sampleSetId/reports'
        : '/experiments/$sampleSetId/samples',
      params: { sampleSetId: params.sampleSetId },
      replace: true,
    });
  },
});
